export default __webpack_public_path__ + "static/media/geo.31c74e3f.svg";